import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { useToast } from './Toast';
import { ProductList } from './Home'; // Import ProductList riêng từ Home.js
import styles from '../styles/Products.module.css';

const Products = () => {
  const [searchParams] = useSearchParams();
  const [search, setSearch] = useState('');
  const { dispatch } = useCart();
  const { success } = useToast();

  // Load search từ URL params
  useEffect(() => {
    const urlSearch = searchParams.get('search');
    if (urlSearch) {
      setSearch(urlSearch);
    }
  }, [searchParams]);

  // Data sản phẩm túi vải dây rút custom
  const allProducts = [
    { id: 1, name: 'Dây rút size nhỏ', price: 20000, image: process.env.PUBLIC_URL + '/hinh1.jpg' },
    { id: 2, name: 'Dây rút size lớn', price: 25000, image: process.env.PUBLIC_URL + '/hinh2.jpg' },
  ];

  // Lọc theo search
  const filteredProducts = allProducts.filter(p => 
    p.name.toLowerCase().includes(search.toLowerCase())
  );

  const handleAddToCart = (product) => {
    dispatch({ type: 'ADD_TO_CART', payload: product });
    success('Đã thêm vào giỏ hàng!');
  };

  return (
    <div className={styles.products}>
      <h1>Túi Vải Dây Rút Custom</h1>
      <p className={styles.subtitle}>Khám phá bộ sưu tập túi vải dây rút độc đáo, có thể tùy chỉnh theo ý bạn</p>
      <input
        type="text"
        placeholder="Tìm kiếm sản phẩm..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className={styles.searchInput}
      />
      <ProductList products={filteredProducts} limit={allProducts.length} onAddToCart={handleAddToCart} />
    </div>
  );
};

export default Products;